<app-form-container>
  <app-register-form></app-register-form>
</app-form-container>
